import { useHasBusinessCapability } from '../../shell/session/hooks/useEffectiveBusinessCapabilities';

export function useMenuModifiersEnabled(): boolean {
  return useHasBusinessCapability('menu_modifiers');
}
